module.exports = __webpack_public_path__ + "img/Send.7db750c9.svg";